import { Graph, type NetworkGraph, type NetworkGraphValues } from '@/models/graph';
import { signedApiClient } from './apiClient';


class AnalyticsService {

  initService() {}

  async getStudyGraphs(identifier: string) {
    const uri = `study/${identifier}/graph`;
    const apiClient = signedApiClient('GET', uri);
    const graphResponse = await apiClient.get(uri);
    return graphResponse.data.map((graph: NetworkGraph) => Graph.mapFrombackend(graph));
  }

  async getGraph(graph: Graph) {
    const uri = `graph/${graph.identifier}`;
    const apiClient = signedApiClient('GET', uri);
    const graphResponse = await apiClient.get(uri);
    return Graph.mapGraphFromBackend(graph, graphResponse.data);
  }

  async postGraph(identifier: string, postGraph: NetworkGraphValues) {
    const uri = `study/${identifier}/graph`;
    const apiClient = signedApiClient('POST', uri);
    return await apiClient.post(uri, {
      values: postGraph
    });
  }

  async deleteGraph(identifier: string) {
    const uri = `graph/${identifier}`;
    const apiClient = signedApiClient('DELETE', uri);
    return await apiClient.delete(uri);
  }
}

export default new AnalyticsService();
